import React, { useState } from 'react';

interface Props {
  children: React.ReactNode;
  label: string;
}

// SPA fork of admin/ContentAudit/Disclosure — a quiet, editorial expand/collapse.
const SPADisclosure = ({ children, label }: Props) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="tw-flex tw-flex-col tw-gap-3">
      <button
        className={[
          'tw-w-fit tw-cursor-pointer tw-appearance-none tw-border-0 tw-bg-transparent tw-p-0',
          'tw-text-sm tw-font-bold tw-text-spa-accent-text',
          'hover:tw-text-spa-accent-text-hover hover:tw-underline',
        ].join(' ')}
        type="button"
        onClick={() => setOpen(value => !value)}
      >
        {open ? '▾' : '▸'} {label}
      </button>
      {open && children}
    </div>
  );
};

export default SPADisclosure;
